<template>
    <section class="content">
        <box>
            <div slot="body">
                <form>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Nome de Usuário</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="userName">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Foto</label>
                    <div class="col-sm-10">
                        <input type="file" id="file-input" class="form-control">
                        <p id="status">Please select a file</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Email</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="email" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Senha</label>
                    <div class="col-sm-10">
                        <input type="password" id="password" class="form-control" v-model="password" disabled>
                    </div>
                </div>
                <br><br>
                <button v-show="!gravando" class="btn btn-primary" @click="gravar"><i class="fa fa-check" aria-hidden="true"></i>  Gravar</button>
                <button v-show="gravando" class="btn btn-primary"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
                <router-link class="pageLink" to="/alterar-email">
                    <button class="btn btn-primary"><i class="fa fa-envelope" aria-hidden="true"></i>  Alterar Email</button>
                </router-link>
                <router-link class="pageLink" to="/alterar-senha">
                    <button class="btn btn-primary"><i class="fa fa-lock" aria-hidden="true"></i>  Alterar Senha</button>
                </router-link>
                </form>               
            </div>
        </box>
    </section>
</template>
<script>
import Box from './Box'
import axios from 'axios'

export default {
    name: 'MinhaConta',
    components: {
        'box' : Box
    },
    data () {
        return {
            fullName: this.$store.state.nome_completo,
            userName: this.$store.state.nome_usuario,
            url_foto: this.$store.state.foto === 'https://wordsandvideos.com/wp-content/uploads/2016/12/common.png'? '' : this.$store.state.foto,
            email: this.$store.state.email,
            password: window.localStorage.getItem('senha'),
            gravando: false
        }
    },
    methods: {
        gravar () {
            this.gravando = true

            const files = document.getElementById('file-input').files;
            const file = files[0];
            if(file != null){
                this.getSignedRequest(file);
            } else {
                this.url_foto = this.$store.state.foto
                console.log(this.url_foto)
                this.gravarUsuario()
            }
        },
        getSignedRequest(file){
            const xhr = new XMLHttpRequest();
            console.log(file.name)
            xhr.open('GET', this.$store.state.api+`s3/sign-s3?file-name=${file.name}&file-type=${file.type}`);
            xhr.onreadystatechange = () => {
                if(xhr.readyState === 4){
                    if(xhr.status === 200){
                        const response = JSON.parse(xhr.responseText);
                        this.uploadFile(file, response.signedRequest, response.url);
                    }
                    else{
                        alert('Could not get signed URL.');
                    }
                }
            };
            xhr.send();
        },
        uploadFile(file, signedRequest, url){
            console.log('signed: ',signedRequest)
            console.log('url: ',url)
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', signedRequest);
            xhr.onreadystatechange = () => {
                if(xhr.readyState === 4){
                    if(xhr.status === 200){
                        this.url_foto = url;
                        // console.log()
                        this.gravarUsuario();
                    }
                    else{
                        alert('Por favor, selecione uma imagem.');
                        this.gravando = false
                    }
                }
            };
            xhr.send(file);
        },
        gravarUsuario() {
            axios.post('https://dashboard-sev.herokuapp.com/usuarios/alter', {
                'nome_usuario': this.userName,
                'nome_completo': this.fullName,
                'foto': this.url_foto,
                'email': this.email
            }).then((response) => {
                if (response.data.success) {
                    this.$swal({
                            position: 'top-end',
                            type: 'success',
                            title: 'Gravado com sucesso',
                            showConfirmButton: false,
                            timer: 1500
                        })   
                        this.$router.push('dashboard')
                } else {
                    this.$swal(
                    'Ops!',
                    'O usuário não foi gravado.',
                    'error'
                    )
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// MinhaConta.vue?8c433c4c